// MIT License

// Copyright (c) React Training 2015-2019
// Copyright (c) Remix Software 2020-2022

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

import React, { lazy, Suspense } from "react";
import './App.css';
import { Route, Routes } from 'react-router-dom';
import About from './pages/About';
// import Gallery from './pages/Gallery';
// import Testimonials from './pages/Testimonials';
// import Home from './pages/Home';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
// import Calculators from './pages/Calculators';
import ScrollToTop from "./components/ScrollToTop";
// import Accountopeningform from './pages/Accountopeningform';
// import Services from './pages/Services';
import Loader from "./components/Loader"

import { Helmet } from 'react-helmet';

const Gallery = lazy(() => import("./pages/Gallery"));
const Home = lazy(() => import("./pages/Home"));
const Testimonials = lazy(() => import("./pages/Testimonials"));
const Calculators = lazy(() => import("./pages/Calculators"));
const Accountopeningform = lazy(() => import("./pages/Accountopeningform"));
const Services = lazy(() => import("./pages/Services"));


// config({ ssrFadeout: true });
function App() {
  return (
    // <BrowserRouter>
    <>
    <Helmet>
        <title>Pratham Investments - AMFI Registered Mutual Fund Distributor</title>
        <meta name="description" content="Pratham Investments is your trusted choice for managing financial assets. We specialize in Mutual Funds, SIP, Lumpsum, and various investment options to help our clients achieve financial freedom and maximize returns on investments." />
      </Helmet>
      <ScrollToTop />
      <Suspense fallback={<Loader></Loader>}>
        <Routes>
          <Route path='/' element={<><Navbar></Navbar><Footer></Footer></>}>
            <Route path='/' element={<Home></Home>}></Route>
            <Route path='/about' element={<About></About>}></Route>
            <Route path='/services' element={<Services></Services>}></Route>
            <Route path='/gallery' element={<Gallery></Gallery>}></Route>
            <Route path='/testimonials' element={<Testimonials></Testimonials>}></Route>
            <Route path='/calculators' element={<Calculators></Calculators>}></Route>
            <Route path='/accountopeningform' element={<Accountopeningform></Accountopeningform>}></Route>
          </Route>
        </Routes>
      </Suspense>
    </>
    // </BrowserRouter>
  );
}

export default App;
